export default function printMe() {
  console.log('I get called from print.js!');
}



// WEBPACK FOOTER //
// ./public/javascripts/print.js